const template = `
<button type="button" class="uoe-btn-lid uoe-btn-secondary" data-consent-change>Change cookie settings</button>
`

export default template
